import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AppAuthenticated } from "./AppAuthenticated";
import { Loader } from "./components/Loader";
import { ScrollToTop } from "./components/ScrollToTop";
import { useAppContext } from "./hooks/useEnvironment";
import { Capture } from "./pages/Capture";

export const App = () => {
  const isReady = useAppContext();

  if (!isReady) {
    return <Loader message="Loading..." showMessage={true} fullPage />;
  }

  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/capture">
          <Capture />
        </Route>
        <Route path="*">
          <AppAuthenticated />
        </Route>
      </Switch>
    </Router>
  );
};
